<template>
  <v-dialog v-model="visible" max-width="350" persistent transition="dialog-top-transition">
      <v-card>
            <v-card-title>
                <v-icon color="primary" class="mr-3">mdi-chat-alert-outline</v-icon> 
                {{titulo}}
            </v-card-title>
            <v-card-text>
                <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-card-text>
            <v-card-text class="d-flex justify-center ">
                <b>{{descripcion}}</b>                
            </v-card-text>          
      </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'DialogoCargando',
    props:{
        visible: Boolean,
        titulo: String,
        descripcion: String
    },    
}
</script>

<style>

</style>